"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
var _bricksUtils = require("@titelmedia/bricks-utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Video = ({
  videoType,
  providerUid,
  applyToDevice,
  usePadding,
  aspectRatio,
  setPosterImage,
  posterImage,
  autoplay,
  autopause,
  muted,
  loop,
  triggerInViewport,
  parallax,
  parallaxNumber = 5,
  controlColors,
  hideControls
}) => {
  const wrapperRef = (0, _react.useRef)(null);
  const videoRef = (0, _react.useRef)(null);
  const playerRef = (0, _react.useRef)(null);
  const fluid = (posterImage === null || posterImage === void 0 ? void 0 : posterImage.fluid) || (posterImage === null || posterImage === void 0 ? void 0 : posterImage.responsiveImage) || posterImage;
  const videoOptions = {
    controls: ['play', 'progress', 'mute', 'volume', 'fullscreen'],
    autoplay: triggerInViewport ? false : autoplay,
    autopause,
    muted,
    loop: {
      active: loop
    },
    ratio: aspectRatio
  };
  (0, _react.useEffect)(() => {
    if (!(typeof window !== 'undefined' && typeof document !== 'undefined') || !wrapperRef.current) return;
    let triggerInViewportAnimation;
    const Plyr = require('plyr');
    require('plyr/dist/plyr.css');
    playerRef.current = new Plyr(videoRef.current, videoOptions);
    if (triggerInViewport) {
      const {
        offsetHeight
      } = wrapperRef.current;
      triggerInViewportAnimation = _bricksUtils.gsap.to(wrapperRef.current, {
        scrollTrigger: {
          trigger: wrapperRef.current,
          start: 'top top',
          end: `+=${offsetHeight}`,
          pin: true,
          onEnter: () => {
            var _playerRef$current;
            return (_playerRef$current = playerRef.current) === null || _playerRef$current === void 0 ? void 0 : _playerRef$current.play();
          },
          onEnterBack: () => {
            var _playerRef$current2;
            return (_playerRef$current2 = playerRef.current) === null || _playerRef$current2 === void 0 ? void 0 : _playerRef$current2.play();
          },
          onLeave: () => {
            var _playerRef$current3;
            if (((_playerRef$current3 = playerRef.current) === null || _playerRef$current3 === void 0 ? void 0 : _playerRef$current3.currentTime) > 0) playerRef.current.pause();
          },
          onLeaveBack: () => {
            var _playerRef$current4;
            if (((_playerRef$current4 = playerRef.current) === null || _playerRef$current4 === void 0 ? void 0 : _playerRef$current4.currentTime) > 0) playerRef.current.pause();
          }
        }
      });
    }
    if (parallax) {
      _bricksUtils.gsap.matchMedia().add(`(min-width: ${_breakpoints.BREAKPOINTS.sm}px)`, () => {
        _bricksUtils.gsap.effects.parallax(wrapperRef.current, {
          yPercent: parallaxNumber,
          trigger: wrapperRef.current
        });
      });
    }
    return () => {
      var _playerRef$current5;
      if (triggerInViewport) triggerInViewportAnimation.kill();
      (_playerRef$current5 = playerRef.current) === null || _playerRef$current5 === void 0 ? void 0 : _playerRef$current5.destroy();
    };
  }, [triggerInViewport, providerUid]);
  return _react.default.createElement(_styles.VideoContainer, {
    ref: wrapperRef,
    triggerInViewport: triggerInViewport,
    applyToDevice: applyToDevice
  }, _react.default.createElement(_styles.Container, {
    usePadding: !(usePadding === false)
  }, _react.default.createElement(_styles.Content, {
    setPosterImage: setPosterImage,
    aspectRatio: aspectRatio,
    hideControls: hideControls,
    controlColors: (controlColors === null || controlColors === void 0 ? void 0 : controlColors.hex) || controlColors
  }, _react.default.createElement(_styles.VideoContent, {
    ref: videoRef,
    "data-plyr-provider": videoType,
    "data-plyr-embed-id": providerUid,
    "data-poster": fluid === null || fluid === void 0 ? void 0 : fluid.src
  }))));
};
exports.Video = Video;
//# sourceMappingURL=index.js.map